export default __webpack_public_path__ + "static/pragicts-ourshare-banner-1-12cd796789fe258720c15472eb20a2e4.jpg";